"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _antd = require("antd");
var _roster = _interopRequireDefault(require("../../services/roster"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
class PersonSelect extends _react.default.Component {
  state = {
    loading: false,
    personId: null,
    person: null,
    persons: []
  };
  static getDerivedStateFromProps(props, state) {
    if (props.value === state.personId) {
      return null;
    }
    return {
      personId: props.value,
      person: null,
      persons: []
    };
  }
  componentDidMount() {
    const {
      personId,
      person,
      loading
    } = this.state;
    if (!loading && personId && personId !== person?.id) {
      this.loadPerson(this.state.personId);
    }
  }
  componentDidUpdate() {
    const {
      personId,
      person,
      loading
    } = this.state;
    if (!loading && personId && personId !== person?.id) {
      this.loadPerson(this.state.personId);
    }
  }
  render() {
    const {
      ...props
    } = this.props;
    const {
      loading,
      personId,
      person,
      persons
    } = this.state;
    const options = [];
    if (persons.length === 0) {
      if (personId && person?.id === personId) {
        options.push({
          value: person.id,
          label: `${person.givenName} ${person.surname} (${person.username})`
        });
      } else if (personId) {
        options.push({
          value: personId,
          label: /*#__PURE__*/_react.default.createElement(_antd.Spin, {
            size: "small"
          })
        });
      }
    }
    persons.forEach(person => {
      options.push({
        value: person.id,
        label: `${person.givenName} ${person.surname} (${person.username})`
      });
    });
    return /*#__PURE__*/_react.default.createElement(_antd.Select, _extends({
      loading: loading,
      showSearch: true,
      optionFilterProp: "children",
      filterOption: false,
      onSearch: this.handleSearch,
      options: options
    }, props));
  }
  handleSearch = (input, option) => {
    this.searchPersons(input);
  };
  loadPerson = async personId => {
    const {
      auth
    } = this.props;
    this.setState({
      loading: true
    });
    try {
      const rosterService = new _roster.default(auth.state);
      const person = await rosterService.getPerson(personId);
      this.setState({
        person,
        loading: false
      });
    } catch (error) {
      console.error(error);
      this.setState({
        loading: false,
        person: {
          id: personId,
          givenName: '¯\\_(ツ)_/¯',
          surname: '',
          username: 'NOT FOUND'
        }
      });
    }
  };
  searchPersons = async searchText => {
    const {
      auth
    } = this.props;
    if (!searchText) {
      this.setState({
        loading: false,
        persons: []
      });
      return;
    }
    this.setState({
      loading: true
    });
    try {
      const rosterService = new _roster.default(auth.state);
      const persons = await rosterService.searchPersons(searchText);
      this.setState({
        persons,
        loading: false
      });
    } catch (error) {
      console.error(error);
      this.setState({
        loading: true
      });
    }
  };
}
exports.default = PersonSelect;
//# sourceMappingURL=person-select.js.map